import {Popover} from '@material-ui/core'
import React from 'react'
import moment from 'moment'
import './PopEventDisplay.scss'
import PopEventDisplayItem from './PopEventDisplayItem'
const PopEventDisplay = ({
  open,
  anchorEl,
  onClose,
  data,
  title,
  sub_title,
  anchorPosition = null,
  onClickEvent = (e, ev) => {},
}) => {
  const {data: items} = data
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorReference={anchorPosition ? 'anchorPosition' : null}
      anchorPosition={anchorPosition}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      classes={{
        paper: 'c-res-mod c-pop-event-display',
      }}
    >
      <div className="c-pop-event-display__header">
        <h4 className="c-pop-event-display__header-title">
          <span style={{fontWeight: '300'}}>{title} </span> {sub_title}
        </h4>
      </div>
      <div className="c-pop-event-display__body ap-scrollbar">
        <div className="c-pop-event-display__body-wrapper">
          {items.map(item => (
            <PopEventDisplayItem key={item.id} item={item} onClickEvent={onClickEvent} />
          ))}
        </div>
      </div>
    </Popover>
  )
}

export default PopEventDisplay
